<div
    class="odds-card card-special sticky-virtual-scroll-item"
    [attr.data-eventid]="event.id"
    (click)="goToEvent(false, $event)"
    data-crlat="oddsCard.specialsTemplate">
    <div class="odds-content" data-crlat="oddsContent">
        <div class="odds-left" data-crlat="oddsLeft">
            <div class="odds-names odds-names-wrap" data-crlat="oddsNames" [textContent]="oddsName"></div>
        </div>
        @if (outcomes.length === 1 && outcomes[0].prices.length !== 0) {
            <div class="odds-right" data-crlat="oddsRight">
                <price-odds-button [event]="event" [market]="event.markets[0]" [outcome]="outcomes[0]" [gtmModuleTitle]="gtmModuleTitle">
                </price-odds-button>
            </div>
        }
        @if (outcomes.length > 1) {
            <div class="odds-right chevron-to-right">
                <svg>
                    <use xlink:href="#next-arrow"></use>
                </svg>
            </div>
        }
    </div>

    @if (isSmartBoosts && wasPrice) {
        <div class="odds-footer">
            <div class="odds-left">
                <span [textContent]="eventTime"></span>
            </div>
            <div class="odds-right">
                <div class="was-price">
                    <span [i18n]="'sb.wasPrice'"></span>
                    <strike [textContent]="wasPrice"></strike>
                </div>
            </div>
        </div>
    }
</div>
